// extracted by mini-css-extract-plugin
module.exports = {"block":"_8267","title":"_3989","rate":"_3073","average":"_9343","status":"_1775","item":"_19283","red":"_7884","divider":"_18999"};